import padStart from 'lodash/padStart';

export function formatStepTitle(title: string, step: number) {
  return `${padStart(`${step + 1}`, 2, '0')}. ${title}`;
}
